import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  FormControl,
  Select,
  MenuItem,
  Divider,
} from "@mui/material";

type Props = {
  open: boolean;
  onClose: () => void;
  documentTypes: string[];
  selectedType: string;
  onChange: (value: string) => void;
  onSelect: () => void;
};

const DocumentTypeModal: React.FC<Props> = ({
  open,
  onClose,
  documentTypes,
  selectedType,
  onChange,
  onSelect,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{ "& .MuiDialog-paper": { width: 500, maxWidth: "unset" } }}
    >
      <DialogTitle>Add More Document</DialogTitle>
      <Divider sx={{ opacity: 0.3 }} />
      <DialogContent>
        <FormControl fullWidth>
          <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
            Document Type
          </Typography>
          <Select
            value={selectedType}
            onChange={(e) => onChange(e.target.value)}
            displayEmpty
            renderValue={(selected) => {
              if (!selected) {
                return (
                  <Typography sx={{ color: "text.disabled" }}>
                    Select a document type
                  </Typography>
                );
              }
              return selected;
            }}
          >
            {documentTypes.map((type) => (
              <MenuItem key={type} value={type}>
                {type}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={onSelect}
          disabled={!selectedType}
          sx={{ textTransform: "none", color: "secondary.contrastText" }}
        >
          Select
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DocumentTypeModal;
